import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { eventOn, eventOff, triggerEvent } from '../helpers/global';

import SidebarView from './SidebarView.js';
import VenuesDropdown from './common/VenuesDropdown';

import '../sass/components/HeaderView.scss';

const mapStoreToProps = (store) => {
  return {
    user: store.data.user,
    venues: store.data.venues || [],
    isMobile: store.setup.isMobile,
  }
};

class HeaderView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      historyDepth: 1,
      title: null,
    };
  }

  componentDidMount = () => {
    this.props.history.listen((loc, type) => {
      if (type === 'PUSH') {
        this.setState({historyDepth: this.state.historyDepth + 1, title: null});
      } else if (type === 'POP') {
        this.setState({historyDepth: this.state.historyDepth - 1, title: null});
      } else {
        this.setState({title: null});
      }
    });
    eventOn('setHeaderTitle', this.setHeaderTitle);
  }

  componentWillUnmount = () => {
    eventOff('setHeaderTitle', this.setHeaderTitle);
  }

  setHeaderTitle = (e) => {
    const { title } = e.detail[0];
    this.setState({title});
  }

  onLogout = () => {
    triggerEvent('showConfirmation', [{
      title: 'Are you sure want to logout?',
      confirmText: 'Logout',
      cancelText: 'Cancel',
      callback: confirm => {
        if (confirm) {
          this.props.onLogout();
        }
      }
    }]);
  }

  renderOutletButton = () => {
    const venues = this.props.user.venues.filter(i => this.props.venues.includes(i.id));
    return (
      <div className='outletButton'>
        <div className='outletTitle'>
          {venues.length === 0 ? 'Select outlet' : venues.map(i => i.name).join(', ')}
        </div>
        <VenuesDropdown anchorRight/>
      </div>
    )
  }

  render = () => {
    if (!this.props.user) {
      return null;
    }
    const menuOpen = !this.props.isMobile || this.state.menuOpen;
    return (
      <div className='headerView'>
        <div className='headerLogo'/>
        <div className='pageInfo'>
          <div className='pageTitle'/>
          {this.renderOutletButton()}
        </div>
        {/*this.state.historyDepth > 1 ?
          <span className='backLink' onClick={() => this.props.history.goBack()}>
            <span className='material-icons'>keyboard_backspace</span>
          </span>
        : null*/}
        {this.props.isMobile ?
          <span className='menuButton' onClick={() => this.setState({menuOpen: !menuOpen})}>
            <span className='material-icons'>menu</span>
          </span>
        : null}
        <SidebarView
          open={menuOpen}
          onClose={() => this.setState({menuOpen: false})}
          onLogout={this.onLogout}
        />
      </div>
    )
  }

}

export default connect(mapStoreToProps)(withRouter(HeaderView));
